// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectTokenVerifyMessage } from "../../../../Utils/DirectMessages/DirectTokenVerifyMessage.js"
export let TokenVerifyResponseMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

TokenVerifyResponseMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

TokenVerifyResponseMessageProcessor.prototype.decode = function (fs)
{
    let msg = new DirectTokenVerifyMessage()
    let ff = FieldsFactory

    msg.Login = fs.GetValue(ff.FIELD_LOGIN)
    msg.IsExpired = fs.GetValue(ff.FIELD_IS_TOKEN_EXPIRED)
    msg.RequestID = fs.GetValue(ff.FIELD_REQUEST_ID) || fs.GetValue(ff.FIELD_SEQUANCE_ID)

    return [msg];
}